import script from "./Depro.vue?vue&type=script&setup=true&lang=ts"
export * from "./Depro.vue?vue&type=script&setup=true&lang=ts"

import "./Depro.vue?vue&type=style&index=0&id=ecd31a42&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecd31a42"]])

export default __exports__